var map = {
	"./icon-map-marker-poi-1100.png": 1657,
	"./icon-map-marker-poi-3100.png": 3931,
	"./icon-map-marker-poi-3150.png": 9892,
	"./icon-map-marker-poi-3300.png": 9178,
	"./icon-map-marker-poi-3350.png": 9528,
	"./icon-map-marker-poi-8200.png": 4564,
	"./icon-map-marker-poi-8300.png": 411,
	"./icon-map-marker-poi-active-1100.png": 9025,
	"./icon-map-marker-poi-active-3100.png": 2067,
	"./icon-map-marker-poi-active-3150.png": 4953,
	"./icon-map-marker-poi-active-3300.png": 3246,
	"./icon-map-marker-poi-active-3350.png": 4657,
	"./icon-map-marker-poi-active-8200.png": 2966,
	"./icon-map-marker-poi-active-8300.png": 4957,
	"./icon-map-marker-poi-active-default.png": 7070,
	"./icon-map-marker-poi-default.png": 8645,
	"./icon-map-marker-poi-man-active.png": 3715,
	"./icon-map-marker-poi-man.png": 3420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7370;